import React from 'react';
import AltIso from 'alt/utils/AltIso';
import SeoActions from '../actions/SeoActions';
import CancelShiftModal from '../components/CancelShiftModal';
import _ from 'lodash';
import moment from 'moment';

import connectToStores from 'alt/utils/connectToStores';
import doRedirect from '../utils/doRedirect';
import withRouter from '../utils/with-router';

import ShiftStore from '../stores/ShiftStore';
import ShiftActions from '../actions/ShiftActions';
import LoadingView from '../components/LoadingView';
import EditShiftHeader from '../components/EditShiftHeader';
import EditShiftPosition from '../components/EditShiftPosition';
import EditShiftSettings from '../components/EditShiftSettings';
import EditShiftDetails from '../components/EditShiftDetails';

@AltIso.define((props) => {
    return SeoActions.pushTitle('Edit Shift');
})

@connectToStores
@withRouter
class EditShift extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: 1,
            formDataDetails: {},
            formDataPosition: {},
            formDataPayment: {},
            formCompleteData: {},
            formErrorsDetails: {},
            formErrorsPosition: {},
            formErrorsPayment: {},
            showCancelShiftModal: false,
            hasChanged: false,
            publishReady: false,
            message: '',
            messageError: false
        };

        if (parseInt(props.params.shiftId) !== 0) {
            ShiftStore.getShift(props.params.shiftId)
        }
    }

    componentDidMount() {
        const shift = parseInt(this.props.params.shiftId) === 0 ? this.props.sStore.dummyShift : this.props.sStore.detailShift;
        this.setState({publishReady: this.validatePublishReady(shift)});
    }

    componentWillReceiveProps(nextProps) {
        const shift = nextProps.sStore.detailShift;
        const data = _.merge({}, this.state.formDataDetails, this.state.formDataPosition, this.state.formDataPayment);
        const createError = nextProps.sStore.createError;

        if (this.props.sStore.detailShiftReceived && Object.keys(data).length > 0) {
            this.setState({publishReady: this.validatePublishReady(data)});
        }

        if (createError.errors && Object.keys(createError.errors).filter(x => x.indexOf('generic') >= 0)) {
            this.setState({activeTab: 1});
        }

        if (Object.keys(shift).length && (moment(shift.end_time) < moment() || shift.status == 'ended')) {
            if (shift.status != 'finished') {
                doRedirect(this.context.router, 'finish_shift', {shiftId: this.props.params.shiftId});
            } else {
                doRedirect(this.context.router, 'agenda');
            }
            return;
        }

        if (nextProps.sStore.shiftCancelled == this.props.params.shiftId) {
            if ((this.props.sStore.detailShift.candidates_hired || 0) > 0) {
                doRedirect(this.context.router, 'finish_shift', {shiftId: this.props.params.shiftId});
            } else {
                doRedirect(this.context.router, 'agenda');
            }

            return;
        }
    }

    static getPropsFromStores() {
        return {
            sStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore];
    }

    tabClick(i) {
        this.setState({
            activeTab: i
        });
    }

    toggleCancelShiftModal() {
        this.setState({
            showCancelShiftModal: !this.state.showCancelShiftModal
        });
    }

    formOnChange(formData, errors, step, changed) {
        const data = _.merge({}, this.state.formDataDetails, this.state.formDataPosition, this.state.formDataPayment, formData);
        data.rate = parseFloat(data.rate) || '';
        const newState = {
            formCompleteData: data,
            changed: changed || false,
            publishReady: this.validatePublishReady(data)
        };
        if (step == 1) {
            newState.formDataDetails = formData;
            newState.formErrorsDetails = errors;
        } else if (step == 2) {
            newState.formDataPosition = formData;
            newState.formErrorsPosition = errors;
        } else if (step == 3) {
            newState.formDataPayment = formData;
            newState.formErrorsPayment = errors;
        }
        this.setState(newState);
    }

    validatePublishReady(formData) {
        const checks = [
            typeof formData.start_date !== 'undefined',
            typeof formData.start_time !== 'undefined',
            typeof formData.end_time !== 'undefined',
            typeof formData.address !== 'undefined' && formData.address !== '',
            typeof formData.street_number !== 'undefined' && formData.street_number !== '',
            typeof formData.contact_persons !== 'undefined' && formData.contact_persons.length > 0,
            (
                typeof formData.payment_method_id !== 'undefined' && formData.payment_method_id !== null
            ) || (
                typeof formData.payment !== 'undefined' && formData.payment !== ""
            ),
            (
                typeof formData.payment_delivery_info !== 'undefined' && formData.payment_delivery_info !== null && formData.payment_delivery_info !== ''
            ) || (
                typeof formData.paymentDescription !== 'undefined' && formData.paymentDescription !== null && formData.paymentDescription !== ''
            ),
            typeof formData.position !== 'undefined' && formData.position !== null && formData.position !== '',
            typeof formData.rate !== 'undefined' && formData.rate !== null && formData.rate !== '',
            typeof formData.workers_needed !== 'undefined' && formData.workers_needed !== null && formData.workers_needed !== ''
        ];

        if (formData.contact_persons && Object.keys(formData.contact_persons).length) {
            formData.contact_persons.forEach(contact_person => {
                if (!contact_person.name || !contact_person.phone || !contact_person.email) {
                    checks.push(false);
                }
            });
        }

        return checks.every(item => item == true);
    }

    saveShift() {
        let errors = _.assign({}, this.state.formErrorsDetails, this.state.formErrorsPosition, this.state.formErrorsPayment);
        if (Object.keys(errors).length > 0) {
            ShiftActions.mergeErrorsIntoState(errors);
        } else {
            if (parseInt(this.props.params.shiftId) === 0) {
                ShiftActions.createShift(this.state.formDataDetails, this.state.formDataPosition, this.state.formDataPayment, null, this.context.router);
            } else {
                ShiftActions.editShift(this.props.params.shiftId, this.state.formDataDetails, this.state.formDataPosition, this.state.formDataPayment, this.context.router);
            }
            this.setState({formErrorsDetails: {}, formErrorsPosition: {}, formErrorsPayment: {}});
        }
    }

    saveDraft() {
        let errors = {};
        let data = _.merge({}, this.state.formDataDetails, this.state.formDataPosition, this.state.formDataPayment);
        if (!this.state.formDataDetails.venue) {
            errors = _.merge({}, errors, {venue: "/venue is 'null' should be a 'String'"});
        }

        if (!this.state.formDataDetails.start_date) {
            errors = _.merge({}, errors, {start_date: "Please choose a starting date"});
        }

        if (!this.state.formDataDetails.start_time) {
            errors = _.merge({}, errors, {start_time: "Please enter a start time"});
        }

        if (!this.state.formDataDetails.end_time) {
            errors = _.merge({}, errors, {end_time: "Please enter a end time"});
        }

        if (!this.state.formDataDetails.address) {
            errors = _.merge({}, errors, {address: "Please make sure you added an address"});
        }

        if (Object.keys(errors).length > 0 || typeof errors == typeof undefined) {
            ShiftActions.mergeErrorsIntoState(errors);
        } else {
            const shift = parseInt(this.props.params.shiftId) === 0 ? this.props.sStore.dummyShift : this.props.sStore.detailShift;
            ShiftActions.saveDraft(data, shift.id, this.context.router);
        }
    }

    cancelShift() {
        const requireMessage = (this.props.sStore.detailShift.candidates_hired || 0) > 0;
        const message = this.state.message;
        if (!requireMessage || message.length > 0) {
            ShiftStore.cancelShift(this.props.params.shiftId, message);
        } else {
            this.setState({
                messageError: true
            });
        }
    }

    changeCancelMessage(e) {
        const requireMessage = (this.props.sStore.detailShift.candidates_hired || 0) > 0;
        // Replace HTML tags with empty string like we did before
        const message = e.target.value.replace(/<\/?[^>]+(>|$)/g, "");
        this.setState({
            message,
            messageError: requireMessage && message.length == 0
        });
    }

    render() {
        const shift = parseInt(this.props.params.shiftId) === 0 ? this.props.sStore.dummyShift : this.props.sStore.detailShift;
        const disabled = shift.candidates_hired + shift.candidates_pending > 0;

        if (Object.keys(shift).length == 0 || !this.props.sStore.detailShiftReceived) {
            return <LoadingView />;
        }
        return (
            <div className="view-edit-shift">
                <EditShiftHeader
                    changed={this.state.changed}
                    publishReady={this.state.publishReady}
                    saveShift={this.saveShift.bind(this)}
                    saveDraft={this.saveDraft.bind(this)}
                    user={this.props.user.profile}
                    shift={shift} />

                <div className="view-content maxwidth-wrapper">

                    <div className="tabs">
                        <button onClick={this.tabClick.bind(this, 1)} className={"tab" + (this.state.activeTab === 1 ? " active" : "")}><span>Shift details</span></button>
                        <button onClick={this.tabClick.bind(this, 2)} className={"tab" + (this.state.activeTab === 2 ? " active" : "")}><span>Position</span></button>
                        <button onClick={this.tabClick.bind(this, 3)} className={"tab" + (this.state.activeTab === 3 ? " active" : "")}><span>Other settings</span></button>
                    </div>

                    <div className="whitebox tab-content">
                        <EditShiftDetails onChange={this.formOnChange.bind(this)} shift={shift} disabled={disabled} isActive={(this.state.activeTab === 1)} />
                        <EditShiftPosition onChange={this.formOnChange.bind(this)} shift={shift} disabled={disabled} isActive={(this.state.activeTab === 2)} />
                        <EditShiftSettings onChange={this.formOnChange.bind(this)} shift={shift} disabled={disabled} isActive={(this.state.activeTab === 3)} />
                    </div>

                    {parseInt(this.props.params.shiftId) == 0 ? <div className="edit-shift-footer"></div> :
                        <div className="cancel-shift">

                            <div className="left">
                                <div className="left-content">
                                    <h3>Cancel shift</h3>
                                    <p>The shift will be unpublished and approved candidates will be notified.</p>
                                </div>
                            </div>

                            <div className="right">
                                <div className="right-content">
                                <button onClick={this.toggleCancelShiftModal.bind(this)} className="btn btn-small btn-bordered">Cancel shift</button>
                                </div>
                            </div>

                        </div>}

                </div>
                <CancelShiftModal pending_candidates={shift.candidates_pending}
                                  hired_candidates={shift.candidates_hired}
                                  changeCancelMessage={this.changeCancelMessage.bind(this)}
                                  cancelShift={this.cancelShift.bind(this)}
                                  toggleModal={this.toggleCancelShiftModal.bind(this)}
                                  isVisible={this.state.showCancelShiftModal}
                                  messageError={this.state.messageError} />
            </div>
        )
    }
}


export default EditShift;



/** WEBPACK FOOTER **
 ** ./app/src/views/EditShift.js
 **/